import { format } from "date-fns";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as Yup from "yup";
const CheckSentAddEdit = ({
  show,
  onHide,
  donation,
  onConfirm,
}) => {
  const isEdit = donation?.transaction_status === "Check Sent";

  const initialValues = {
    check_number: donation?.cheque_number || "",
    check_date: donation?.cheque_date || "",
  };

  const handleSubmit = (values) => {
    const payload = {
      appointment_id: donation.appointment_id,
      payment_type: "cheque",
      cheque_number: values.check_number,
      cheque_date: values.check_date,
    };

    onConfirm(payload);
    onHide();
  };

const validationSchema = Yup.object({
  check_number: Yup.string()
    .required("Check number is required")
    .matches(/^[1-9][0-9]{0,19}$/, "Check number must be 1–20 digits and cannot start with zero"),
  check_date: Yup.string().required("Check date is required"),
});

  return (
    <Modal show={show} centered onHide={onHide} dialogClassName="el-deactivate-modal">
      <Modal.Body>
        <h5 className="mb-3">
          {isEdit ? "Edit Check Details" : "Add Check Number & Date"}
        </h5>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values, setFieldValue, setFieldTouched }) => (
            <Form>
              {/* Check Number */}
              <div className="mb-3">
                <label className="form-label">Check Number <span className="text-danger"> *</span></label>
                <Field
                  name="check_number"
                  type="text"
                  className="form-control"
                  placeholder="Enter check number"
                />
                <ErrorMessage
                  name="check_number"
                  component="div"
                  className="text-danger small"
                />
              </div>

              {/* Check Date */}
              <div className="mb-3">
                <label className="form-label">Check Date <span className="text-danger"> *</span></label>
                <DatePicker
                  selected={values.check_date ? new Date(values.check_date) : null}
                  onChange={(date) => {
                    const formatted = date ? format(date, "MMMM d, yyyy") : "";
                    setFieldValue("check_date", formatted);
                    setFieldTouched("check_date", true);
                  }}
                  dateFormat="MMMM d, yyyy"
                  placeholderText="Month Date, Year"
                  className="form-control"
                  showMonthDropdown
                  showYearDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={50}
                  maxDate={new Date()}
                />
                <ErrorMessage
                  name="check_date"
                  component="div"
                  className="text-danger small"
                />
              </div>

              {/* Actions */}
              <div className="d-flex justify-content-end mt-4">
                <button
                  type="submit"
                  className="el-main-button"
                >
                  <span>{isEdit ? "Update" : "Submit"}</span>
                </button>

                <button
                  type="button"
                  className="back-link close-btn ms-3"
                  onClick={onHide}
                >
                  Close
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default CheckSentAddEdit;
